export const DEFAULT_LAST_CONSUMED_MESSAGE_INDEX = -1;

export const UNREAD_COUNT_DISPLAY_THRESHOLD = 99;
